
export type NgSearchTypesEnum = number;
export let NgSearchTypesEnum: any = {};
NgSearchTypesEnum.ON_TABLE = 0;
NgSearchTypesEnum.ON_BACKEND = 1;
NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND = 2;
NgSearchTypesEnum[NgSearchTypesEnum.ON_TABLE] = "ON_TABLE";
NgSearchTypesEnum[NgSearchTypesEnum.ON_BACKEND] = "ON_BACKEND";
NgSearchTypesEnum[NgSearchTypesEnum.EMPTY_TABLE_APPLY_BACKEND] = "EMPTY_TABLE_APPLY_BACKEND";

